import { Schemas } from "../types/api-types";
import apiClient from "../clients/apiClient";
import { ApiResponse } from "../schemas/apiResponseSchema";

export type SystemHealthResponse = Schemas['SystemHealthResponse'];

/**
 * Fetch system health status
 */
export async function getSystemHealth(): Promise<SystemHealthResponse> {
    try {
        const response: ApiResponse<SystemHealthResponse> = (
            await apiClient.get('/system/health')
        ).data;
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.detail || 'Failed to fetch system health');
        }
        throw new Error('Network error, please contact support team');
    }
}
